import { Trans } from '@lingui/macro'
import { useRouter } from 'next/router'
import { FC, useState } from 'react'

import { FeedObjectAnswer, FeedUserView } from '../../../interfaces'
import { GreenWhatsapp } from '../../icons'
import Answer from '../Answer'
import AnswerComment from '../AnswerComment'
import styles from './AnswerDetails.module.css'

interface Props {
  answer: FeedObjectAnswer
  questionText: string
  profiles: { [userId: string]: FeedUserView }
}

const collpasedCommentCount = 2

const AnswerDetails: FC<Props> = props => {
  const router = useRouter()
  const [isCollapsed, setIsCollapsed] = useState(true)

  const comments = props.answer.commentList || []

  const commentItems = comments
    .slice(0, isCollapsed ? collpasedCommentCount : comments.length)
    .map(comment => <AnswerComment comment={comment} key={comment.commentId} profile={props.profiles[comment.userId]} />)

  const answerProfile = props.profiles[props.answer.userId]
  const answerLink = `${process.env.NEXT_PUBLIC_DOMAIN}/${router.asPath}#${props.answer.id}`
  const whatsappText =
    (answerProfile?.fullName ? `*Read answer by ${answerProfile.fullName}*\n\n` : '') +
    `*Question Text*-${props.questionText}\n` +
    `*Answer Text*- ${props.answer.answerText.value}\n\n` +
    `*Read full answer: ${answerLink}*\n\n` +
    `*I’m using Healofy: India’s largest women app :dancer: to get FREE answers from doctors :female-scientist: & experts for all questions about women & child health, career advice, pregnancy, beauty & weight loss tips:grinning:*\n\n` +
    `*Ask your question NOW for FREE: ${answerLink}*`

  const whatsappLink = `https://wa.me?text=${encodeURIComponent(whatsappText)}`

  return (
    <div className={styles.wrapper} id={props.answer.id}>
      <Answer answer={props.answer} profile={answerProfile} />
      <a className={styles.whatsappShare} href={whatsappLink}>
        <GreenWhatsapp />
        <span className={styles.share}>
          <Trans>Share</Trans>
        </span>
      </a>
      <div>{commentItems}</div>
      {comments.length > collpasedCommentCount && isCollapsed ? (
        <div className={styles.viewAll}>
          <span onClick={() => setIsCollapsed(false)}>
            <Trans>View all {comments.length} comments</Trans> ›
          </span>
        </div>
      ) : null}
    </div>
  )
}

export default AnswerDetails
